module.exports = __webpack_public_path__ + "3d297ffa4064aa3f9636d2b365b6ae18.png";